/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  SearchContainer,
  SearchIcon,
  SearchInput,
  SearchRelativeContainer,
} from "./LandingPage.styles.js";

import { selectBusinessUserInfo } from "../../store/slices/businessUser/slice.js";

const SearchComponent = ({ search, marginOff }) => {
  const navigate = useNavigate();
  const { loggedIn } = useSelector(selectBusinessUserInfo);

  const [searchTerm, setSearchTerm] = useState(search ?? "");

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && searchTerm !== "") {
      if (loggedIn) {
        navigate(`/admin-portal/search?searchTerm=${searchTerm}`);
      } else {
        navigate(`/search?searchTerm=${searchTerm}`);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keypress", handleKeyPress);

    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <SearchContainer $marginOff={marginOff}>
      <SearchRelativeContainer>
        <SearchIcon
          $active={searchTerm !== ""}
          onClick={() => {
            window.scrollTo(0, 0);
            if (searchTerm) {
              if (loggedIn) {
                navigate(`/admin-portal/search?searchTerm=${searchTerm}`);
              } else {
                navigate(`/search?searchTerm=${searchTerm}`);
              }
            }
          }}
        />
        <SearchInput
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search for unique gifts collections or brands..."
        />
      </SearchRelativeContainer>
    </SearchContainer>
  );
};

export default SearchComponent;
